import classNames from "classnames"
import style from "components/SingleImage.module.scss"
import { motion } from "framer-motion"
import Img from "gatsby-image"
import camelCase from "lodash/camelCase"
import React from "react"
import { useInView } from "react-intersection-observer"

const SingleImage = ({ image, highlightPosition, highlightColor }) => {
  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5
  })

  const className = classNames(
    style.root,
    style[`root___highlightColor_${camelCase(highlightColor)}`],
    style[`root___highlightPosition_${camelCase(highlightPosition)}`]
  )

  return (
    <div className={className} ref={ref}>
      <div className={style.content}>
        <div className={style.image}>
          <div className={style.highlight} />
          <div className={style.img}>
            {!!image && (
              <Img
                placeholderStyle={{ visibility: "hidden" }}
                fluid={image?.fluid}
              />
            )}{" "}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleImage
